import { render, staticRenderFns } from "./ExportView.vue?vue&type=template&id=20f60bcd"
import script from "./ExportView.vue?vue&type=script&lang=js"
export * from "./ExportView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports